import React, { useState } from "react";
import { FaEnvelope, FaClock, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import headerBg from "./assets/picOne.png"; // header image
import buildingImg from "./assets/picOne.png"; // building image

const ContactUs = () => {
  const [activeTab, setActiveTab] = useState("head");

  const themeColor = "#ff5400";

  const headOffice = {
    name: "Malawi Bureau of Standards",
    address: "Ali Hassan Mwinyi Road\nP.O Box 946\nBlantyre\nMalawi",
    email: "mbs@mbsmw.org",
    tel: "+265 1 870 488",
  };

  // Regional offices data
  const regionalOffices = [
    
    {
      region: "Central Region - Lilongwe Office",
      address: "P O Box 156\nLilongwe\nMalawi",
      tel: "+265 1 758 341",
      fax: "+265 1 758 418",
      email: "mbs@mbsmw.org",
    },
    {
      region: "Northern Region - Mzuzu Office",
      
      address: "P O Box 200419\nMzuzu\nMalawi",
      tel: "+265 1 320 434",
      fax: "+265 1 320 434",
      email: "mbs@mbsmw.org",
    },
  ];

  const boarderOffices = [
    {
      region: "Southern Region - Chileka International Airport Satellite Office",
      tel: "+265 1 870 017",
      email: "mbs@mbsmw.org",
    },
    {
      region: "Central Region - Kamuzu International Airport (KIA) Satellite Office",
      tel: "+265 1 758 341",
      fax: "+265 1 758 418",
      email: "mbs@mbsmw.org",
    },

    {
      region: "Southern Region - Mloza Boarder Office",
      tel: "+265 1 870 017",
      email: "mbs@mbsmw.org",
    },

    {
      region: "Southern Region - Mwanza Boarder Office",
      tel: "+265 1 870 017",
      email: "mbs@mbsmw.org",
    },

    {
      region: "Central Region - Dedza Boarder Office",
      tel: "+265 1 758 341",
      fax: "+265 1 758 418",
      email: "mbs@mbsmw.org",
    },

    {
      region: "Central Region - Mchinji Boarder Office",
      tel: "+265 1 758 341",
      fax: "+265 1 758 418",
      email: "mbs@mbsmw.org",
    },

    

    {
      region: "Northern Region - Songwe Boarder Office",
      tel: "+265 1 320 434",
      fax: "+265 1 320 434",
      email: "mbs@mbsmw.org",
    },

    {
      region: "Northern Region - Chitipa Boarder Office",
      tel: "+265 1 320 434",
      fax: "+265 1 320 434",
      email: "mbs@mbsmw.org",
    },
  ];

  const hours = [
    { day: "Monday - Friday", time: "7:30 AM - 12:00 PM, 1:00 PM - 4:30 PM", status: "Open" },
    { day: "Lunch Break", time: "12:00 PM - 1:00 PM", status: "Break" },
    { day: "Weekend & Public Holidays", time: "7:30 AM - 12:00 PM, 1:00 PM - 4:30 PM", status: "Closed" }
  ];

  // Function to render offices in a 2-column grid
  const renderOfficesGrid = (offices) => (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "25px" }}>
      {offices.map((office, idx) => (
        <div key={idx} style={{ background: "#fff", padding: "15px", borderRadius: "8px", boxShadow: "0 3px 10px rgba(0,0,0,0.07)" }}>
          <h4 style={{ fontWeight: 600, marginBottom: "6px" }}>{office.region}</h4>
          <p style={{ margin: "2px 0" }}></p>
          {office.dept && <p style={{ margin: "2px 0" }}>{office.dept}</p>}
          <p style={{ margin: "2px 0", whiteSpace: "pre-line" }}>{office.address}</p>
          <p style={{ margin: "2px 0" }}>Tel: {office.tel}</p>
          {office.fax && <p style={{ margin: "2px 0" }}>Fax: {office.fax}</p>}
          <p style={{ margin: "2px 0" }}>E-mail: <a href={`mailto:${office.email}`} style={{ color: themeColor }}>{office.email}</a></p>
        </div>
      ))}
    </div>
  );

  return (
    <div style={{ fontFamily: "'Inter', sans-serif", background: "#f7f7f8" }}>
      
      {/* === Header Overlay Section === */}
      <section
        style={{
          backgroundImage: `url(${headerBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "40vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            background: "rgba(0,0,0,0.55)",
            padding: "40px",
            textAlign: "center",
            color: "white",
            width: "90%",
            maxWidth: "1200px",
            borderRadius: "12px",
            borderRight: "4px solid #ff6600",
            borderLeft: "4px solid #ff6600",
          }}
        >
          <h1 style={{ fontSize: "2rem", fontWeight: 700, marginBottom: "10px" }}>Contact Us</h1>
          <p style={{ fontSize: "1rem", color: "rgba(255,255,255,0.9)" }}>
            Reach out to MBS to receive innovative solutions for your business
          </p>
        </div>
      </section>

      {/* === Main Content Panels === */}
      <div style={{ display: "flex", justifyContent: "center", padding: "40px", gap: "40px", flexWrap: "wrap" }}>

        {/* Left Panel: Offices */}
        <div style={{ flex: "1 1 px", background: "#f8f8f8", borderRadius: "12px", padding: "30px", boxShadow: "0 6px 18px rgba(0,0,0,0.08)" }}>
          
          {/* Tabs */}
          <div style={{ display: "flex", gap: "20px", marginBottom: "30px", borderBottom: "1px solid #ddd" }}>
            {["head", "regional", "import"].map(tab => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                style={{
                  padding: "10px 20px",
                  border: "none",
                  borderBottom: activeTab === tab ? `3px solid ${themeColor}` : "3px solid transparent",
                  background: "transparent",
                  color: activeTab === tab ? themeColor : "#555",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                {tab === "head" ? "HEADOFFICE" : tab === "regional" ? "REGIONAL OFFICES" : "SATELLITE / BORDER OFFICES"}
              </button>
            ))}
          </div>

          {/* === HEAD OFFICE TAB === */}
          {activeTab === "head" && (
            <div>
              <h4 style={{ fontWeight: 700, marginBottom: "12px", fontSize: "1.15rem" }}>Working Hours</h4>
              <ul style={{ listStyle: "none", padding: 0, marginBottom: "20px" }}>
                {hours.map((h, i) => {
                  let bgColor =
                    h.status === "Open"
                      ? "#ff6c2f"
                      : h.status === "Break"
                      ? "#777"
                      : "#000";

                  return (
                    <li
                      key={i}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "14px",
                        marginBottom: "10px",
                        fontSize: "0.95rem",
                      }}
                    >
                      <span style={{ width: "230px", fontWeight: 600 }}>{h.day}</span>
                      <span style={{ width: "320px", fontWeight: 400 }}>{h.time}</span>

                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          background: bgColor,
                          color: "#fff",
                          padding: "4px 10px",
                          borderRadius: "6px",
                          fontSize: "0.78rem",
                          fontWeight: 600,
                        }}
                      >
                        {h.status}
                        <FaClock size={13} />
                      </span>
                    </li>
                  );
                })}
              </ul>

              {/* Head Office Details */}
              <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                <FaMapMarkerAlt style={{ marginRight: "10px", color: themeColor }} />
                <div>
                  <strong>Location</strong>
                  <p style={{ margin: 0, whiteSpace: "pre-line", fontSize: "0.95rem" }}>{headOffice.address}</p>
                </div>
              </div>

              <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                <FaEnvelope style={{ marginRight: "10px", color: themeColor }} />
                <div>
                  <strong>Email us</strong>
                  <p style={{ margin: 0 }}>
                    <a href={`mailto:${headOffice.email}`} style={{ color: themeColor, textDecoration: "none" }}>
                      {headOffice.email}
                    </a>
                  </p>
                </div>
              </div>

              <div style={{ display: "flex", alignItems: "center" }}>
                <FaPhoneAlt style={{ marginRight: "10px", color: themeColor }} />
                <div>
                  <strong>Call us</strong>
                  <p style={{ margin: 0 }}>{headOffice.tel}</p>
                </div>
              </div>
            </div>
          )}

          {/* === REGIONAL OFFICES === */}
{activeTab === "regional" && (
  <div>
    {/* Working Hours */}
    <h4 style={{ fontWeight: 700, marginBottom: "12px", fontSize: "1.15rem" }}>
      Working Hours
    </h4>
    <ul style={{ listStyle: "none", padding: 0, marginBottom: "20px" }}>
      {hours.map((h, i) => {
        let bgColor =
          h.status === "Open"
            ? "#ff6c2f"
            : h.status === "Break"
            ? "#777"
            : "#000";

        return (
          <li
            key={i}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "14px",
              marginBottom: "10px",
              fontSize: "0.95rem",
            }}
          >
            <span style={{ width: "230px", fontWeight: 600 }}>{h.day}</span>
            <span style={{ width: "320px", fontWeight: 400 }}>{h.time}</span>

            <span
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                background: bgColor,
                color: "#fff",
                padding: "4px 10px",
                borderRadius: "6px",
                fontSize: "0.78rem",
                fontWeight: 600,
              }}
            >
              {h.status}
              <FaClock size={13} />
            </span>
          </li>
        );
      })}
    </ul>

    {/* Offices Grid */}
    {renderOfficesGrid(regionalOffices)}
  </div>
)}

          {/* === IMPORT INSPECTION OFFICES === */}
{activeTab === "import" && (
  <div>
    {/* Working Hours for Import Offices */}
    <h4 style={{ fontWeight: 700, marginBottom: "12px", fontSize: "1.15rem" }}>
      Working Hours
    </h4>
    <ul style={{ listStyle: "none", padding: 0, marginBottom: "20px" }}>
      {hours.map((h, i) => {
        // Modify status for weekend
        const status = h.day === "Weekend & Public Holidays" ? "Open" : h.status;
        let bgColor =
          status === "Open"
            ? "#ff6c2f"
            : status === "Break"
            ? "#777"
            : "#000";

        return (
          <li
            key={i}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "14px",
              marginBottom: "10px",
              fontSize: "0.95rem",
            }}
          >
            <span style={{ width: "230px", fontWeight: 600 }}>{h.day}</span>
            <span style={{ width: "320px", fontWeight: 400 }}>{h.time}</span>

            <span
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                background: bgColor,
                color: "#fff",
                padding: "4px 10px",
                borderRadius: "6px",
                fontSize: "0.78rem",
                fontWeight: 600,
              }}
            >
              {status}
              <FaClock size={13} />
            </span>
          </li>
        );
      })}
    </ul>

    {/* Offices Grid */}
    {renderOfficesGrid(boarderOffices)}
  </div>
)}


        </div>

        {/* === Right Panel: Contact Form === */}

        <div style={{ flex: "0 1 350px", background: "#f8f8f8", borderRadius: "12px", padding: "20px", boxShadow: "0 6px 18px rgba(0,0,0,0.08)" }}>
          <h3 style={{ marginBottom: "15px" }}>Send us a message</h3>
          <img src={buildingImg} alt="MBS Building" style={{ width: "100%", height: "auto", borderRadius: "8px", marginBottom: "15px" }} />
          <form 
            action="https://api.web3forms.com/submit" 
            method="POST"
            style={{ display: "flex", flexDirection: "column", gap: "12px" }}
          >
            
            <input type="hidden" name="access_key" value="5de595f3-4d50-4915-aa7d-971167cef568" />
            <input type="checkbox" name="botcheck" style={{ display: "none" }} />

            <input type="hidden" name="from_name" value="MBS Website Contact Form" />

            <input type="hidden" name="subject" value="ATTENTION: NEW MESSAGE FROM MBS WEBSITE" />

            <input type="text" name="name" placeholder="Your name" style={inputStyle} />
            <input type="email" name="email" placeholder="Your Email Address" style={inputStyle} />
            <input type="text" name="phone" placeholder="Phone Number" style={inputStyle} />
            <textarea name="message" placeholder="Describe your message" rows="4" style={inputStyle} />

            <button type="submit" style={{ ...submitBtnStyle, background: themeColor }}>
              Submit your message
            </button>
          </form>

        </div>

        
        {/* <div style={{ flex: "0 1 350px", background: "#f8f8f8", borderRadius: "12px", padding: "20px", boxShadow: "0 6px 18px rgba(0,0,0,0.08)" }}>
          <h3 style={{ marginBottom: "15px" }}>Send us a message</h3>
          <img src={buildingImg} alt="MBS Building" style={{ width: "100%", height: "auto", borderRadius: "8px", marginBottom: "15px" }} />
          <form style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <input type="text" placeholder="Your name" style={inputStyle} />
            <input type="email" placeholder="Your Email Address" style={inputStyle} />
            <input type="text" placeholder="Phone Number" style={inputStyle} />
            <textarea placeholder="Describe your message" rows="4" style={inputStyle} />
            <button type="submit" style={{ ...submitBtnStyle, background: themeColor }}>Submit your message</button>
          </form>
        </div> */}
      </div>
      <div style={{ position: "relative", width: "100%", height: "500px", marginTop: "40px", borderRadius: "12px", overflow: "hidden", boxShadow: "0 6px 18px rgba(0,0,0,0.08)" }}>
  {/* Title above the pin */}
  <div style={{
    position: "absolute",
    top: "43%", // adjust this to position above the pin
    left: "50%",
    transform: "translate(-50%, -100%)", // moves it above center point
    zIndex: 10,
    background: "rgba(255,255,255,0.9)",
    padding: "6px 12px",
    borderRadius: "6px",
    fontWeight: 600,
    color: "#ff5400",
    fontSize: "0.95rem",
    textAlign: "center",
    whiteSpace: "nowrap"
  }}>
    Malawi Bureau of Standards - Head Office
  </div>

  <iframe
    title="MBS Head Office Map"
    width="100%"
    height="100%"
    frameBorder="0"
    style={{ border: 0 }}
    src="https://www.google.com/maps?q=-15.798305813642118,35.031013340629066&hl=en&z=16&output=embed"
    allowFullScreen
  ></iframe>
</div>

    </div>

    
  );
};

const inputStyle = {
  padding: "12px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  outline: "none",
  fontSize: "0.95rem",
};

const submitBtnStyle = {
  padding: "12px",
  background: "#ff5400",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  fontWeight: 600,
  cursor: "pointer",
};

export default ContactUs;
